import React, { useRef } from 'react';

import { Theme, styled } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../../theme';
import Select from '../../Select/Select';

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      width: '100%',
    },
    selectHeader: {
      width: '100%',
      justifyContent: 'space-between',
    },
  }),
);

const StyledSelect = ({ ...props }) => {
  const classes = useStyles();
  const selectRef = useRef<HTMLDivElement>(null);

  return (
    <SelectWrapper ref={selectRef}>
      <Select
        anchorRef={selectRef}
        className={classes.wrapper}
        selectBtnClass={classes.wrapper}
        selectHeaderClass={classes.selectHeader}
        widthByAnchor
        {...props}
      />
    </SelectWrapper>
  );
};

export default StyledSelect;

const SelectWrapper = styled('div')(({ theme }: { theme: Theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  marginBottom: 24,
  borderRadius: '999em',
  background: colorsPalette.violetAnalyticsCard,
  justifyContent: 'space-around',
  width: '100%',
  padding: '5px 15px',
  position: 'relative',
  [theme.breakpoints.up('md')]: {
    width: 'auto',
    padding: '5px 35px',
  },
}));
